import React, { useState } from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import PlanterGardenComponent from "./PlanterGardenComponent";
import RibbonNav from "./RibbonNav";
import '../css/ScrollbarStyling.css';
import '../css/gardenPlanterStylings/InGroundGardenGridPlanterStyling.css';

import VeggieSelector from "./VeggieSelector";
import PlotPlanter from "./gardenPlanterComponents/PlotPlanter";

const InGroundGardenGridPlanter = () => {
    const { state } = useLocation();
    const { savedGardenPlots } = state;

    const [selectedGarden, setSelectedGarden] = useState(null);
    const [showVeggieSelector, setShowVeggieSelector] = useState(false);
    const [totalSpace, setTotalSpace] = useState(0);
    const [plantedGardens, setPlantedGardens] = useState({});
    const [showPlotPlanter, setShowPlotPlanter] = useState(false);
    const [isGardenSaved, setIsGardenSaved] = useState({}); // when user saves garden this updates for the button text to change again
    const navigate = useNavigate();

    function getTotalSpace(gardenMatrix) {
        const total = gardenMatrix.split('\n').map(row => row.split(',').map(Number)).flat().reduce((acc, curr) => acc + curr, 0);
        setTotalSpace(total);
    }

    const handleGardenClick = (gardenName) => {
        getTotalSpace(savedGardenPlots[gardenName].matrix);

        if (plantedGardens[gardenName] && !isGardenSaved[gardenName]) {
            // show the plot planter!
            setShowVeggieSelector(false);
            setSelectedGarden(gardenName);
            setShowPlotPlanter(true);
        } else if (!isGardenSaved[gardenName]) {
            // show veggie selector
            setShowPlotPlanter(false);
            setSelectedGarden(gardenName);
            setShowVeggieSelector(true);
        }
    };

    const handleVeggieSelect = (veggie) => {
        // You can now add the veggie to the selected garden in your state or DB
        console.log(`Selected veggie ${veggie.name} for ${selectedGarden}`);
        setShowVeggieSelector(false);
    };

    const handlePlantSelectionToGarden = (plantData) => {
        console.log("Received plants from VeggieSelector:", plantData);

        setPlantedGardens(prev => ({
            ...prev,
            [selectedGarden]: {
                gardenInfo: savedGardenPlots[selectedGarden], // Include all garden information
                plants: plantData // Include the selected plants
            }
        }));

        setSelectedGarden(null);
        setShowVeggieSelector(false);
    };

    const handleGardenSaveToDB = (data) => {
        console.log(data);
        setIsGardenSaved(prev => ({
            ...prev,
            [data]: true
        }));
        setShowPlotPlanter(false);
    }

    return (
        <div className="in-ground-garden-grid-planter">
            <RibbonNav pageName={"Veggie Planter"} />
            <div className="garden-plot-selector">
                {Object.entries(savedGardenPlots).map(([gardenName, gardenData]) => (
                    <div key={gardenName}>
                        <PlanterGardenComponent
                            gardenName={gardenName}
                            gardenMatrix={gardenData.matrix}
                            gardenHardiness={gardenData.hardiness}
                            gardenSoilType={gardenData.soilType}
                            gardenSunlight={gardenData.sunlight}
                            gardenMaintenance={gardenData.maintenance}
                            planted={!!plantedGardens[gardenName]}
                            selected={selectedGarden === gardenName}
                            badgeButtonClick={handleGardenClick}
                            saved={!!isGardenSaved[gardenName]}
                        />
                    </div>
                ))}
            </div>

            {Object.keys(isGardenSaved).length === Object.keys(savedGardenPlots).length &&
                Object.keys(savedGardenPlots).length > 0  && (
                <div className="all-gardens-saved-modal">
                    <div className="modal-overlay">
                        <div className="modal-content">
                            <h2>🎉 Yay! You planted all your gardens! 🎉</h2>
                            <p>Everything’s in the ground and ready to grow.
                                Let’s head back and see your beautiful garden dashboard.</p>
                            <button
                                className="finish-button"
                                onClick={() => navigate("/dashboard")} // navigate to the dashboard
                            >
                                🌱 Finish & Go Home
                            </button>
                        </div>
                    </div>
                </div>
                )}

            {showVeggieSelector && (
                <div className="veggie-selector-popup">
                    <VeggieSelector onSelect={handleVeggieSelect}
                                    totalSpace={totalSpace}
                                    gardenInformation={savedGardenPlots[selectedGarden]}
                                    onAddPlants={handlePlantSelectionToGarden}
                    />
                </div>
            )}

            {showPlotPlanter && (
                <div className={"next-steps-container"}>
                    <PlotPlanter gardenName={selectedGarden} gardenInformation={plantedGardens[selectedGarden]}
                                 gardenSavedToDB={(data) => handleGardenSaveToDB(data)}/>
                </div>
            )}
        </div>
    );
};

export default InGroundGardenGridPlanter;
